import {
  CREATE_ACCOUNT_BANK,
  CREATE_ACCOUNT_BANK_FAIL,
  CREATE_ACCOUNT_BANK_SUCCESS,
  CREATE_USER_INVOICE,
  CREATE_USER_INVOICE_FAIL,
  CREATE_USER_INVOICE_SUCCESS,
  DELETE_USER_INVOICE,
  DELETE_USER_INVOICE_FAIL,
  DELETE_USER_INVOICE_SUCCESS,
  EDIT_USER_INVOICE,
  EDIT_USER_INVOICE_FAIL,
  EDIT_USER_INVOICE_SUCCESS,
  GET_ALL_ACCOUNT_BANK,
  GET_ALL_ACCOUNT_BANK_FAIL,
  GET_ALL_ACCOUNT_BANK_SUCCESS,
  GET_ALL_USER_INVOICE,
  GET_ALL_USER_INVOICE_FAIL,
  GET_ALL_USER_INVOICE_SUCCESS,
  GET_DETAIL_USER_INVOICE,
  GET_DETAIL_USER_INVOICE_FAIL,
  GET_DETAIL_USER_INVOICE_SUCCESS,
  GET_LIST_USER_INVOICE,
  GET_LIST_USER_INVOICE_FAIL,
  GET_LIST_USER_INVOICE_SUCCESS,
  RESET_CREATE_ACCOUNT_BANK,
  RESET_CREATE_USER_INVOICE,
  RESET_DELETE_USER_INVOICE,
  RESET_EDIT_USER_INVOICE,
  RESET_LIST_USER_INVOICE,
  SET_COLUMN_VISIBLE_USER_INVOICE,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  // Khách hàng
  user: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  detailUser: {
    loading: false,
    data: null,
    error: null,
  },
  createUser: {
    loading: false,
    data: null,
    error: null,
  },
  editUser: {
    loading: false,
    data: null,
    error: null,
  },
  deleteUser: {
    loading: false,
    data: null,
    error: null,
  },
  createAccountBankData: {
    loading: false,
    data: null,
    error: null,
  },
  listVat: [],

  listAllUser: [],
  loadListAllUser: false,

  listAllAccountBank: [],
  loadListAllAccountBank: false,
};

const userInvoice = (state = INIT_STATE, action) => {
  const curUser = state.user;
  switch (action.type) {
    // Khách hàng
    case GET_LIST_USER_INVOICE:
      return {
        ...state,
        user: {
          ...curUser,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_USER_INVOICE_SUCCESS:
      return {
        ...state,
        user: {
          ...curUser,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_USER_INVOICE_FAIL:
      return {
        ...state,
        user: {
          ...curUser,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_USER_INVOICE:
      return {
        ...state,
        user: {
          ...curUser,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Detail Khách hàng
    case GET_DETAIL_USER_INVOICE:
      return {
        ...state,
        detailUser: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DETAIL_USER_INVOICE_SUCCESS:
      return {
        ...state,
        detailUser: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_DETAIL_USER_INVOICE_FAIL:
      return {
        ...state,
        detailUser: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    // Tạo khách hàng
    case CREATE_USER_INVOICE:
      return {
        ...state,
        createUser: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_USER_INVOICE_SUCCESS:
      return {
        ...state,
        createUser: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_USER_INVOICE_FAIL:
      return {
        ...state,
        createUser: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_USER_INVOICE:
      return {
        ...state,
        createUser: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Cập nhật khách hàng
    case EDIT_USER_INVOICE:
      return {
        ...state,
        editUser: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case EDIT_USER_INVOICE_SUCCESS:
      return {
        ...state,
        editUser: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case EDIT_USER_INVOICE_FAIL:
      return {
        ...state,
        editUser: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_EDIT_USER_INVOICE:
      return {
        ...state,
        editUser: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xóa khách hàng
    case DELETE_USER_INVOICE:
      return {
        ...state,
        deleteUser: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case DELETE_USER_INVOICE_SUCCESS:
      return {
        ...state,
        deleteUser: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case DELETE_USER_INVOICE_FAIL:
      return {
        ...state,
        deleteUser: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_DELETE_USER_INVOICE:
      return {
        ...state,
        deleteUser: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // GET_ALL_USER_INVOICE
    case GET_ALL_USER_INVOICE:
      return {
        ...state,
        listAllUser: [],
        loadListAllUser: true,
      };
    case GET_ALL_USER_INVOICE_SUCCESS:
      return {
        ...state,
        listAllUser: action.data,
        loadListAllUser: false,
      };

    case GET_ALL_USER_INVOICE_FAIL:
      return {
        ...state,
        listAllUser: [],
        loadListAllUser: false,
      };
    // Tạo tài khoản ngân hàng
    case CREATE_ACCOUNT_BANK:
      return {
        ...state,
        createAccountBankData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_ACCOUNT_BANK_SUCCESS:
      return {
        ...state,
        createAccountBankData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_ACCOUNT_BANK_FAIL:
      return {
        ...state,
        createAccountBankData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_ACCOUNT_BANK:
      return {
        ...state,
        createAccountBankData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // GET_ALL_USER_INVOICE
    case GET_ALL_ACCOUNT_BANK:
      return {
        ...state,
        listAllAccountBank: [],
        loadListAllAccountBank: true,
      };
    case GET_ALL_ACCOUNT_BANK_SUCCESS:
      return {
        ...state,
        listAllAccountBank: action.data,
        loadListAllAccountBank: false,
      };

    case GET_ALL_ACCOUNT_BANK_FAIL:
      return {
        ...state,
        listAllAccountBank: [],
        loadListAllAccountBank: false,
      };
    // Set column
    case SET_COLUMN_VISIBLE_USER_INVOICE:
      curUser.columnsVisible[action.field] = action.value;
      return {
        ...state,
        user: {
          ...curUser,
        },
      };
    default:
      return state;
  }
};

export default userInvoice;
